import { Router, NavigationEnd } from '@angular/router';
import {Component, HostListener, Injectable, OnInit} from '@angular/core';
import { AuthenticationService } from 'app/service/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  scrHeight: any;
  scrWidth: any;
  loadingFlag: boolean;
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    if (this.scrWidth < 995 ) {
      document.getElementById('ToastBody').className = 'toast-body-responsive';
      document.getElementById('ToastTitle').className = 'toast-title-responsive';
      document.getElementById('ToastDescription').className = 'toast-description-responsive';
    } else {
      document.getElementById('ToastBody').className = 'toast-body';
      document.getElementById('ToastTitle').className = 'toast-title';
      document.getElementById('ToastDescription').className = 'toast-description';
    }
  }

  constructor(public authenticationService: AuthenticationService,
              public router: Router) {
  this.loadingFlag = true;
  }

  ngOnInit() {
    this.getScreenSize();
      this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });
    this.loadingFlag = false;
  }

  notificationOn( type , description ) {
    document.getElementById('ToastBody').style.display = 'block';
    switch (type) {
      case 'error':
        document.getElementById("ToastBody").style.backgroundColor ="rgba(255,99,71)";
        document.getElementById("ToastTitle").innerHTML="Hata";
        break;
      case 'success':
        document.getElementById("ToastBody").style.backgroundColor ="rgba(205, 221, 240)";
        document.getElementById("ToastTitle").innerHTML="Başarılı";
        break;
      case 'warn':
        document.getElementById("ToastBody").style.backgroundColor ="rgba(240, 173, 78)";
        document.getElementById("ToastTitle").innerHTML="Uyarı";
        break;
      default:
        document.getElementById("ToastBody").style.backgroundColor ="rgba(59,195,255,0.8)";
        break;
    }
    document.getElementById("ToastDescription").innerHTML=description;
    setTimeout(function(){document.getElementById("ToastBody").style.display ="none";}, 3000);
  }
  notificationOff() {
    document.getElementById('ToastBody').style.display = 'none';
  }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/otojet-git/OtojetUI-Spring-Admin-Project/src/app/app.component.ts